import FJActionImageEnhancer from '../../redux/action/FJActionImageEnhancer';
import { useDispatch, useSelector } from 'react-redux';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import { useEffect, useCallback, useMemo } from 'react';
import FJMobileDefaultPreview from '../FJMainPreview/FJMobileDefaultPreview/FJMobileDefaultPreview';
import { MOBILE_IMAGE_ENHANCER_PREVIEW_SRC } from '../../config/dataConfig/FJImageEnhancerData';
import FJMobileImageEnhancerCreationContainer from './FJMobileImageEnhancerCreation/FJMobileImageEnhancerCreationContainer';
import FJMobileImageEnhancerFooterContainer from './FJMobileImageEnhancerFooter/FJMobileImageEnhancerFooterContainer';
import { setSliceMobileGenerateSuccessPreviewIndex, setSliceTaskStatusAction } from '../../redux/slices/FJSliceCommon';
import FJConstant from '../../constants/FJConstant';
import useLocalStore from '../../hooks/useLocalStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMobileGenerateSuccessfulContainer from '../FJMainPreview/FJMobileGenerateSuccessful/FJMobileGenerateSuccessfulContainer';

const FJMobileImageEnhancer = () => {
    const dispatch = useDispatch();
    useLocalStore();

    useEffect(() => {
        dispatch(FJActionImageEnhancer.loadImageEnhancerPageAction());
    }, [dispatch]);
    const uploadImageList = useSelector(state => state.imageEnhancer.uploadImageList);
    const hasUploadedImg = uploadImageList && uploadImageList.length > 0 && uploadImageList[0].src;
    const imageEnhancerCreationList = useSelector(state => state.imageEnhancer.imageEnhancerCreationList);

    const previewList = useMemo(() => {
        if (imageEnhancerCreationList[0]) {
            return [
                {
                    ...imageEnhancerCreationList[0],
                    id: imageEnhancerCreationList[0].task_id || imageEnhancerCreationList[0].id,
                },
            ];
        } else return [];
    }, [imageEnhancerCreationList]);

    const uploadImg = useCallback(
        file => {
            dispatch(FJActionImageEnhancer.uploadImagesAction([file]));
        },
        [dispatch],
    );
    const gotoBack = useCallback(() => {
        // 移动端创作区没有对比功能
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
    }, [dispatch]);
    const onRestoreMore = useCallback(
        file => {
            uploadImg(file);
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
        },
        [dispatch, uploadImg],
    );
    const imageRect = useMemo(
        () => ({ width: uploadImageList[0]?.width || 0, height: uploadImageList[0]?.height || 0 }),
        [uploadImageList],
    );
    const title = 'ai-image-upscaler-colorful',
        description = 'enhance-image-resolution-and-improve-visual-effects',
        uploadText = 'upload-image';
    return (
        <>
            {!hasUploadedImg && (
                <FJMobileDefaultPreview
                    title={title}
                    description={description}
                    uploadText={uploadText}
                    uploadImg={uploadImg}
                    videoSrc={MOBILE_IMAGE_ENHANCER_PREVIEW_SRC}
                />
            )}
            {hasUploadedImg && (
                <>
                    <FJMobileGenerateSuccessfulContainer
                        gotoBack={gotoBack}
                        onReEdit={onRestoreMore}
                        gotoBackText={FJLocalStore._('back')}
                        previewList={previewList}
                        reEditText={FJLocalStore._('upscale-more')}
                        imageRect={imageRect}
                    />
                    <FJMobileImageEnhancerFooterContainer />
                    <FJMobileImageEnhancerCreationContainer />
                </>
            )}
            <FJMobileHistoryContainer />
        </>
    );
};
export default FJMobileImageEnhancer;
